module.exports = __webpack_public_path__ + "img/business-icon-02.e185c2be.png";